var Layout = require("app/ui/Layout"),
    kind   = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.HeaderGraphic.RevolutionSliderGraphicLayout.prototype */ {

    /**
     * @private
     */
    name: "app.ui.HeaderGraphic.RevolutionSliderGraphicLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var $container    = this.container,
            layoutMetrics = $container.get("layoutMetrics") || {},
            $slider       = $container.$.slider,
            sliderWidth,
            sliderHeight;

        if (!$container.hasNode()) {
            return;
        }

        // Resolve metrics
        sliderWidth  = layoutMetrics.graphicWidth;
        sliderHeight = layoutMetrics.graphicHeight || 1; // Revolution really doesn't like 0

        // Apply metrics
        $slider.addStyles({
            width:  sliderWidth + "px",
            height: sliderHeight + "px"
        });
    }

});
